import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch, ApiError } from '@/lib/api';
import { useToast } from '@/lib/toast';
import type { KommunikationCreateRequest } from '@/types/detail';

export function useCreateKommunikation(bestellnr: string) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: KommunikationCreateRequest) =>
      apiFetch<{ kommunikation: { id: number } }>('/kommunikation/create.php', {
        method: 'POST',
        body: JSON.stringify(body)
      }),
    onSuccess: () => {
      toast('success', 'Kommunikation erfasst.');
      qc.invalidateQueries({ queryKey: ['bestellung', bestellnr] });
    },
    onError: (err) => {
      const code = err instanceof ApiError ? err.code : 'unbekannt';
      toast('error', `Kommunikation fehlgeschlagen: ${code}`);
    }
  });
}
